import { createContext, useContext } from 'react';

// The browser dialog element: full-modal layers (3D viewer, full-screen gallery) portal into it.
export const BrowserOverlayHostContext = createContext<HTMLElement | null>(null);

export function useBrowserOverlayHost(): HTMLElement | null {
    return useContext(BrowserOverlayHostContext);
}
